import cx from "classnames"
import PropTypes from "prop-types"
import * as css from "./SimpleHeader.module.css"

function SimpleHeader({
  className,
  level = "h2",
  label,
  title,
  subtitle,
  titleSize,
  subtitleSize,
  dash,
  narrow,
  contrasted,
  cta,
}) {
  const Heading = level || "h2"

  return (
    <div className={cx(css.root, className)}>
      <div
        className={cx(css.header, css[`${dash}Dash`], css[`${narrow}Narrow`], {
          [css.contrasted]: !!contrasted,
        })}
      >
        <div className={css.wrapper}>
          {label && <div className={css.label}>{label}</div>}
          <Heading className={cx(css.title, css[titleSize])}>{title}</Heading>
        </div>
        {subtitle && (
          <div className={cx(css.subtitle, css[subtitleSize])}>{subtitle}</div>
        )}
      </div>
      {cta && <div className={css.cta}>{cta}</div>}
    </div>
  )
}

SimpleHeader.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** Used to specify the header level for SEO / styling purposes */
  level: PropTypes.oneOf(["h1", "h2", "h3"]),
  /** Small text that appears above the title */
  label: PropTypes.string,
  /** Title */
  title: PropTypes.string.isRequired,
  /** Subtitle */
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Title size (default: 40px, 48px, 52px, 64px) */
  titleSize: PropTypes.oneOf(["lg", "xl", "xxl"]),
  /** Subtitle size (default: 16px, 24px, 36px) */
  subtitleSize: PropTypes.oneOf(["lg", "xl"]),
  /** If horizontal, add a line decorator to the label; if vertical, add left border */
  dash: PropTypes.oneOf(["horizontal", "vertical"]),
  /** Limit width of title, subtitle or both */
  narrow: PropTypes.oneOf(["title", "subtitle", "both"]),
  /** If true, set light color to subtitle text */
  contrasted: PropTypes.bool,
  /** CTA to include after the subtitle */
  cta: PropTypes.node,
}

export default SimpleHeader
